import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { devxertech.com.pages.HomePage() }
        ctx.router.register("/Hr-Intern") { devxertech.com.pages.career.devxerCareer.HrIntern() }
        ctx.router.register("/ai-services") {
                devxertech.com.pages.services.aiDevelopmentService.AiDevelopmentServices() }
        ctx.router.register("/auraNetwork") {
                devxertech.com.pages.portfolio.auraNetwork.AuraNetwork() }
        ctx.router.register("/blog-Page") { devxertech.com.pages.blogs.blogPages.BlogPage() }
        ctx.router.register("/blogs") { devxertech.com.pages.blogs.MainBlogs() }
        ctx.router.register("/career-page") { devxertech.com.pages.career.CareerPage() }
        ctx.router.register("/chatbot-development") {
                devxertech.com.pages.services.chatbotDevelopment.AiDevelopmentServices() }
        ctx.router.register("/contact-us") { devxertech.com.pages.contactSection.ContactUsSection()
                }
        ctx.router.register("/dev-operation") {
                devxertech.com.pages.services.devOperation.DevOperationSection() }
        ctx.router.register("/fintech-Industry") {
                devxertech.com.pages.industries.fintectIndustry.FintechIndustry() }
        ctx.router.register("/healthcare-system") {
                devxertech.com.pages.industries.healthCare.HealthCareSystem() }
        ctx.router.register("/homepage") { devxertech.com.pages.dashboard.Dashboard() }
        ctx.router.register("/industry-edu") {
                devxertech.com.pages.industries.devIndustryEdu.DevIndustryEdu() }
        ctx.router.register("/mobile-services") {
                devxertech.com.pages.services.mobileServices.MobileAppSection() }
        ctx.router.register("/portfolio") { devxertech.com.pages.portfolio.PortfolioScreen() }
        ctx.router.register("/safeDeposit") {
                devxertech.com.pages.portfolio.safeDeposit.SafeDepositPage() }
        ctx.router.register("/sports-industry") {
                devxertech.com.pages.industries.sportsIndustry.SportsIndustry() }
        ctx.router.register("/tcld") { devxertech.com.pages.portfolio.tcld.TcldPage() }
        ctx.router.register("/ui-services") {
                devxertech.com.pages.services.UxPage.UiUxServicesPage() }
        ctx.router.register("/varcity") { devxertech.com.pages.portfolio.varcity.VarcityPage() }
        ctx.router.register("/web-services") {
                devxertech.com.pages.services.webServices.ServiceSection() }
        ctx.router.register("/zone") { devxertech.com.pages.portfolio.zone.ZonePage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("dropdown-style-light", devxertech.com.style.DropdownStyleLight)
        ctx.theme.registerStyle("dropdown-style-dark", devxertech.com.style.DropdownStyleDark)
        ctx.theme.registerStyle(devxertech.com.style.BaseTextStyle)
        ctx.theme.registerStyle(devxertech.com.style.InputStyleDefault)
        ctx.theme.registerStyle(devxertech.com.style.InputStyleFocus)
        ctx.theme.registerStyle(devxertech.com.style.InputStyleError)
        ctx.theme.registerKeyframes(devxertech.com.section.Spin)
        ctx.theme.registerKeyframes(devxertech.com.section.ShiftRight)
        ctx.theme.registerKeyframes("spin-once", devxertech.com.style.SpinOnce)
        ctx.theme.registerKeyframes("rating-row", devxertech.com.style.RatingRow)
        ctx.theme.registerKeyframes("shift-right1", devxertech.com.style.ShiftRight1)
        ctx.theme.registerKeyframes("opacity", devxertech.com.utils.OpacityKeyframes)
        ctx.theme.registerKeyframes("shift-left", devxertech.com.utils.ShiftLeftKeyframes)
        ctx.theme.registerKeyframes("shift-right", devxertech.com.utils.ShiftRightKeyframes)
        devxertech.com.theme.initTheme(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "DevxerTech"))
    renderComposable(rootElementId = "root") {
        devxertech.com.AppEntry {
            router.renderActivePage { renderWithDeferred { it() } }
        }
    }
}
